<!-- //
商城-地区-列表
@auth xuyd
@date 2024-10-01
//-->
<template>
  <page-layout layout="C">
    <!-- 检索区域 -->
    <div class="layout-search" style="display: flex; flex-direction: row; justify-content: space-between">
      <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
               label-width="100px">
        <el-form-item prop="search">
          <el-input
              v-model="queryParams.search"
              placeholder="请输入检索内容（分类名/拼音）"
              style="width: 320px;text-align: right;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
        <el-button type="primary" size="small" @click="handleAdd" icon="el-icon-plus">添加</el-button>
      </div>
    </div>

    <div class="layout-result" style="height: calc(100% - 63px);">
      <DynamicTable :query-params="queryParams"
                    :selection="true"
                    :data="tableData"
                    :metas="tableMetas"
                    @reload="getList">
        <div slot-scope="{row, item}">
          <el-button size="small" type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button size="small" type="text" @click="handleCopy(row)">复制</el-button>
          <el-button size="small" type="text" @click="handleDelete(row)">删除</el-button>
        </div>
      </DynamicTable>
    </div>
    <AddDlg ref="refAddDlg"/>
  </page-layout>
</template>

<script>
import CategoryApi from '@/api/mall/category.api.js';
import AddDlg from './add';


export default {
  name: 'ViewMallProductMgmtCategoryList',
  components: {AddDlg},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
  ],
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        orderByColumn: null,
        isAsc: null,
        search: null,
      },
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      tableMetas: [
        {prop: 'id', label: "ID", width: 80},
        {prop: 'name', label: "分类名", width: 150, sortable: true, showOverflow: true},
        {prop: 'pinyin', label: "拼音", minWidth: 150},
        {prop: 'pid', label: "父级ID", width: 120, sortable: true},
        {prop: 'level', label: "层级", width: 100},
        {prop: 'leafFlag', label: "叶子节点", width: 100, dataType: 'dict', dictType: 'YES_OR_NO'},
        {prop: 'fullName', label: "分类名全称", minWidth: 180},
        {prop: 'sort', label: "排序", width: 80},
        {prop: 'status', label: "有效状态", width: 80, dataType: 'dict', dictType: 'YES_OR_NO'},
        {prop: '', label: "操作", width: 120, fixed: 'right'},
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      CategoryApi.searchCategoryList(this.queryParams).then(resp => {
        this.tableData.records = resp.data.records.map(item => {
          item.loading = false;
          return item;
        });
        this.tableData.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    handleAdd() {
      this.$refs.refAddDlg.showModal({
        title: '添加',
        mode: 1,
        data: {...this.currentNode},
        onOk: (data) => {
          this.getList();
        }
      });
    },

    handleEdit(row) {
      this.$refs.refAddDlg.showModal({
        title: '编辑',
        mode: 2,
        data: {...row},
        onOk: (data) => {
          this.getList();
        }
      });
    },

    handleCopy(row) {
      let data = {...row};
      data.id = null;
      this.$refs.refAddDlg.showModal({
        data: data,
        mode: 1,
        title: '复制数据',
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 删除
     * @param row
     */
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.name}】吗？`).then(() => {
        CategoryApi.deleteCategory(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },
  }
}
</script>
